import * as LiveUpdates from "@capacitor/live-updates";
import { cachePromiseFor } from "./cache-promise-for";
import { retryWhen } from "./retry-when";

const syncWithRetries = retryWhen(LiveUpdates.sync, {
  shouldRetry: () => true,
  maxRetries: 10,
  retryDelayInMs: 1_000,
});

const tenSecondsInMs = 10_000;
// FIXME: hunt down syncLiveUpdates() calls and diminish them.
export const syncLiveUpdates = cachePromiseFor(tenSecondsInMs, syncWithRetries);
